import React from 'react'

const UpdateTnx = () => {
  return (
    <div>
      
    </div>
  )
}

export default UpdateTnx
